exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fd[data-v-19518006] {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}\n.disabled[data-v-19518006] {\n  color: #999 !important;\n  cursor: not-allowed !important;\n  pointer-events: auto; /* Allow pointer events to be disabled by the parent */\n}\n.disabled *[data-v-19518006] {\n  pointer-events: none;\n}\n", ""]);

// exports
